// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1Neo4jServerStateType = {
  Neo4jServerStateEnabled: 'Enabled',
  Neo4jServerStateFree: 'Free',
  Neo4jServerStateDeallocating: 'Deallocating',
  Neo4jServerStateDeallocated: 'Deallocated',
  Neo4jServerStateDropped: 'Dropped',
  Neo4jServerStateCordoned: 'Cordoned',
} as const;
export type V1Neo4jServerStateType =
  (typeof V1Neo4jServerStateType)[keyof typeof V1Neo4jServerStateType];

export function instanceOfV1Neo4jServerStateType(value: any): boolean {
  for (const key in V1Neo4jServerStateType) {
    if (Object.prototype.hasOwnProperty.call(V1Neo4jServerStateType, key)) {
      if (
        V1Neo4jServerStateType[key as keyof typeof V1Neo4jServerStateType] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1Neo4jServerStateTypeFromJSON(
  json: any,
): V1Neo4jServerStateType {
  return V1Neo4jServerStateTypeFromJSONTyped(json, false);
}

export function V1Neo4jServerStateTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jServerStateType {
  return json as V1Neo4jServerStateType;
}

export function V1Neo4jServerStateTypeToJSON(
  value?: V1Neo4jServerStateType | null,
): any {
  return value as any;
}

export function V1Neo4jServerStateTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1Neo4jServerStateType {
  return value as V1Neo4jServerStateType;
}
